import Component from "../core/Component";

export default class PriceStickyBar extends Component {
   constructor(element) {
      super(element);

      this.stickyTable = document.querySelector(".pricing-table__table--sticky");
      this.header = document.querySelector(".Header");
      this.priceTable = document.getElementById("price-table");
   }

   prepare() {
      if (this.element.classList.contains("calculatedTableColumn")) {
         this.calculatedTableColumn();
         window.onresize = () => {
            this.calculatedTableColumn();
         };
      }

      window.onscroll = () => {
         this.handleStickyTableHeader();
      };

      setTimeout(() => {
         this.handleStickyTableHeader();
      }, 300);
   }

   handleStickyTableHeader() {
      if (window.pageYOffset >= this.priceTable.getBoundingClientRect().top + window.pageYOffset && window.pageYOffset <= this.priceTable.getBoundingClientRect().bottom + window.pageYOffset - 100) {
         this.header.classList.add("no-shadow");
         this.stickyTable.classList.add("is-visible");
      } else {
         this.header.classList.remove("no-shadow");
         this.stickyTable.classList.remove("is-visible");
      }
   }

   calculatedTableColumn() {
      let pricingTableTbody = document.querySelectorAll("#price-table tbody");
      let buttonBlock = document.querySelector(".button-block");
      let buttonBlockSection = document.querySelectorAll(".button-block__section");
      let tableSection = document.querySelectorAll(".table-section");
      let tableCol4 = document.querySelector(".table-col-4");

      buttonBlock.style.width = tableCol4.offsetWidth + "px";
      pricingTableTbody.forEach((elm, index) => {
         buttonBlockSection[index].style.height = elm.offsetHeight - tableSection[index].offsetHeight + "px";
         buttonBlockSection[index].style.marginTop = tableSection[index].offsetHeight + "px";
      });
   }
}